import React, { useState } from "react";
import { createTheme } from "@material-ui/core/styles";
import { blue } from "@material-ui/core/colors";
import ReorderIcon from "@mui/icons-material/Reorder";
import {
  SortableContainer,
  SortableHandle,
  SortableElement,
  arrayMove,
} from "react-sortable-hoc";
import { Box, IconButton, ThemeProvider } from "@mui/material";
import { useEffect } from "react";
import EditCol from "./EditCol";
import ListViewHeader from "../ListViewHeader";
import baseTheme from "../../themes/baseTheme";

const { palette } = baseTheme;

const theme = createTheme({
  palette: {
    primary: {
      main: blue[500],
      dark: blue[700],
    },
  },
});

const DragHandle = SortableHandle(({ style }) => (
  <span style={{ ...style, cursor: "move" }}>
    <IconButton>
      <ReorderIcon />
    </IconButton>
  </span>
));

const SortableBox = SortableElement(({ children }) => (
  <Box style={{ borderColor: "#e0e0e0" }}>{children}</Box>
));
const SortableList = SortableContainer(
  ({
    rows,
    ListItem,
    headersWithWidth,
    showEditCol,
    statusRoleMap,
    ...props
  }) => (
    <Box>
      {headersWithWidth.length > 0 && (
        <ListViewHeader headers={headersWithWidth} padding={"16px 24px"} />
      )}
      {rows.map((row, index) => (
        <SortableBox key={index} index={index}>
          <Box className="row collections-list-view w-100 m-0">
            <Box
              borderBottom="solid 1px"
              borderColor={palette.grey[30]}
              className="col-1 g-0 d-flex align-items-center justify-content-center"
            >
              <DragHandle style={{ marginRight: "8px" }} />
            </Box>
            <Box className="col-11 g-0">
              <ListItem
                className="list-item"
                key={row.key}
                headers={headersWithWidth}
                statusRoleMap={statusRoleMap}
                {...row}
                {...props}
              >
                {showEditCol && <EditCol {...row} {...props} />}
              </ListItem>
            </Box>
          </Box>
        </SortableBox>
      ))}
    </Box>
  )
);

const ResultListOrderable = ({
  headers = [],
  rows = [],
  ListItem,
  ...props
}) => {
  const [showEditCol, setShowEditCol] = useState(false);
  const [headersWithWidth, setHeadersWithWidth] = useState([]);
  const [orderedRows, setOrderedRows] = useState([]);

  useEffect(() => {
    setOrderedRows(rows);
    setShowEditCol(
      props?.isEditable?.isVisible || props?.isDeletable?.isVisible
    );
  }, [rows]);

  useEffect(() => {
    const newHeaders = [...headers];
    if (showEditCol) {
      newHeaders.push({ id: "editCol" });
    }
    const allColsHaveWdith = !headers.find((h) => !h.width);
    if (!allColsHaveWdith) {
      const colWidth = Math.floor(100 / newHeaders.length);
      newHeaders.forEach((h) => (h.width = `${colWidth}%`));
    }
    const hasHeaderText = headers.find((h) => h.text);
    if (hasHeaderText) setHeadersWithWidth(newHeaders);
  }, [headers, showEditCol]);

  const onSortEnd = ({ oldIndex, newIndex }) => {
    const updatedRows = arrayMove(
      orderedRows.length > 0 ? orderedRows : rows,
      oldIndex,
      newIndex
    );
    const rowsWithDisplayOrder = updatedRows.map((row, index) => {
      return {
        ...row,
        displayOrder: index + 1,
      };
    });

    setOrderedRows(rowsWithDisplayOrder);
    props.reOrderedData(rowsWithDisplayOrder);
  };

  return (
    <ThemeProvider theme={theme}>
      <SortableList
        ListItem={ListItem}
        headersWithWidth={headersWithWidth}
        rows={orderedRows.length > 0 ? orderedRows : rows}
        showEditCol={showEditCol}
        statusRoleMap={props.statusRoleMap}
        useDragHandle
        onSortEnd={onSortEnd}
      />
    </ThemeProvider>
  );
};

export default ResultListOrderable;
